/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 * 
 **/
import { createIcon } from "@v2/helpers/icons/create-icon";
export const ViewDeskIcon = createIcon({
  displayName: "ViewDeskIcon",
  viewBox: "0 0 16 16",
  path: (<g fill="none"><path d="M9.00011 14C7.59806 14 6.30833 13.5191 5.28686 12.7133L6.35743 11.6427C7.09947 12.1819 8.01265 12.5 9.00011 12.5C11.4854 12.5 13.5001 10.4853 13.5001 8C13.5001 5.51472 11.4854 3.5 9.00011 3.5C8.01265 3.5 7.09947 3.81806 6.35743 4.35732L5.28686 3.28675C6.30833 2.4809 7.59806 2 9.00011 2C12.3138 2 15.0001 4.68629 15.0001 8C15.0001 11.3137 12.3138 14 9.00011 14Z" fill="currentColor" /><path d="M5.82334 6.76256L2.50011 3.43934L1.43945 4.5L4.76268 7.82322C4.86031 7.92086 4.86031 8.07915 4.76268 8.17678L1.43945 11.5L2.50011 12.5607L5.82334 9.23744C6.50675 8.55402 6.50675 7.44598 5.82334 6.76256Z" fill="currentColor" /></g>)
});